import styled from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-12k5c84-0"
})(["width:", ";width:auto;"], function (_ref) {
  var fullWidth = _ref.fullWidth;
  return fullWidth ? '100%' : '280px';
});
export var PlaceholderBlock = styled.div.withConfig({
  displayName: "partials__PlaceholderBlock",
  componentId: "sc-12k5c84-1"
})(["margin-bottom:24px;color:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.font;
});